import _ from 'lodash';

import DataOption from '../../models/DataOption';
import StatMessages from '../../StatMessages';
import getHoursOffset from '../../../utils/getHoursOffset';

export default class Statistics {
  constructor(intl) {
    if (!intl) {
      throw Error('Missing intl param');
    }

    const hourOffset = getHoursOffset();

    /**
     * Default callqueuereport api params
     * @type {{object: string, action: string, format: string, range_interval: string, value_offset: string}}
     */
    const apiParams = {
      object: 'statistics',
      action: 'read',
      format: 'json',
      range_interval: hourOffset,
      value_offset: hourOffset,
      type: 'queue',
      group: '',
      queue: '*',
      unit: 'seconds',
    };
    // eslint-disable-next-line no-undef
    const apiParamsAgent = _.cloneDeep(apiParams);
    apiParamsAgent.type = 'agent';

    const statMessages = new StatMessages(intl);

    /**
     * add socket subscriptions and events if any
     * Example Props
     * stat: 'AC'
     * socketSubscriptions: [{ type: 'agent' }]
     * socketEvents: [{ name: string, adapter: function, adapterParams: object }] }
     * @type {*[]}
     */
    const stats = [
      { stat: 'AC', ...statMessages.messages.AC, filterCategories: ['callqueue', 'site', 'department'] },
      { stat: 'AH', ...statMessages.messages.AH, defaultFormatType: 'time' },
      {
        // eslint-disable-next-line max-len
        stat: 'AR', ...statMessages.messages.AR, defaultFormatType: 'percent', filterCategories: ['callqueue', 'site', 'department'],
      },
      { stat: 'ATT', ...statMessages.messages.ATT, defaultFormatType: 'time' },
      {
        // eslint-disable-next-line max-len
        stat: 'AWT', ...statMessages.messages.AWT, defaultFormatType: 'time', filterCategories: ['callqueue', 'site', 'department'],
      },
      { stat: 'CH', ...statMessages.messages.CH, apiParams: { ...apiParamsAgent, fields: 'CH' } },
      { stat: 'FWD', ...statMessages.messages.FWD, filterCategories: ['callqueue', 'site', 'department'] },
      {
        // eslint-disable-next-line max-len
        stat: 'SL', ...statMessages.messages.SL, defaultFormatType: 'percent', filterCategories: ['callqueue', 'site', 'department'],
      },
      {
        // eslint-disable-next-line max-len
        stat: 'TT', ...statMessages.messages.TT, defaultFormatType: 'time', filterCategories: ['subscriber'], apiParams: { ...apiParamsAgent, fields: 'TT' },
      },
      { stat: 'VM', ...statMessages.messages.VM, filterCategories: ['callqueue', 'site', 'department'] },
      { stat: 'VOL', ...statMessages.messages.VOL, filterCategories: ['callqueue', 'site', 'department'] },
      { stat: 'AST', ...statMessages.messages.AST, filterCategories: ['callqueue', 'site', 'department'] },
      { stat: 'CB', ...statMessages.messages.CB, filterCategories: ['callqueue', 'site', 'department'] },
    ];

    /**
     * @type {DataOption[]}
     */
    const options = stats.map((stat) => new DataOption({
      type: 'api',
      apiParams: stat.apiParams ? stat.apiParams : { ...apiParams, fields: stat.stat },
      adapter: 'statisticsToSDPAdapter',
      hasCategories: false,
      hasColumns: false,
      supportedCharts: ['ResponsiveStat'],
      xAxis: 'datetime',
      ...stat,
    }));

    this.dataOptions = _.keyBy(options, 'stat');
  }
}
